import { render, staticRenderFns } from "./NewFounder.vue?vue&type=template&id=585ba69c"
import script from "./NewFounder.vue?vue&type=script&lang=js"
export * from "./NewFounder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports